import { useEffect, useMemo, useState } from 'react';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { EnumDragger } from 'components/app/_mediator/app.slice';
import { EMPTY_CELL } from 'components/app/editor/_mediator/editor.slice';
import { setPlayerSeekEnabled } from 'components/app/storyboard/_mediator/sb.slice';

export const usePlayerTimestamp = () => {
  const sbPlayback = useAppSelector((state) => state.sb.sbPlayback);
  const activeClip = useAppSelector((state) => state.editor.activeClip);
  const dragger = useAppSelector((state) => state.app.dragger);
  const heldKey = useAppSelector((state) => state.app.heldKey);
  const [listenDragger, setListenDragger] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (dragger === EnumDragger.cell) setListenDragger(true);
    else if (heldKey !== 'Shift') setListenDragger(false);
  }, [dragger, heldKey]);

  const isVisible = useMemo(() => {
    if (sbPlayback || activeClip === EMPTY_CELL) return false;
    return heldKey === 'Shift' && !listenDragger;
  }, [activeClip, sbPlayback, listenDragger, heldKey]);

  useEffect(() => {
    dispatch(setPlayerSeekEnabled(isVisible));
  }, [isVisible]);

  return isVisible;
};
